type GetSignForTransactionParams = {
  transaction: {
    type: string;
  };
  isMergedTransaction?: boolean;
};

export const getSignForTransaction = ({
  isMergedTransaction,
  transaction,
}: GetSignForTransactionParams) => {
  if (isMergedTransaction || 'toBankAccountId' in transaction) {
    return '';
  }
  return transaction.type === 'payin' ? '+' : '-';
};
